import { Inject, Injectable } from '@angular/core';
import { isNil } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

@Injectable({ providedIn: 'root' })
export class Inventory_ds_inventory_by_lot_selection_gridService {

  constructor(
    private $utils: UtilsService,
    private $settings: SettingsValuesService,
    ) { 
  }

  public async get($inParams: { warehouseId: number, materialId?: number, packagingId?: number, lotId?: number, projectId: number, fullTextSearch?: string, custom_filters?: string[] }): 
  Promise<{ result: { WarehouseId?: number, LotId?: number, PackagedId?: number, PackagedAmount?: number, Lot?: { LastReceiveDate?: string, LookupCode?: string, MaterialId?: number, VendorLot?: { ExpirationDate?: string, LookupCode?: string, ManufactureDate?: string, Vat?: string }, Material?: { Description?: string, LookupCode?: string, Name?: string }, Status?: { Name?: string } }, Packaging?: { ShortName?: string } }[] }> 
  {
    const $missingRequiredInParams = [];
    if (isNil($inParams.warehouseId)) {
      $missingRequiredInParams.push('\'warehouseId\'');
    }
    if (isNil($inParams.projectId)) {
      $missingRequiredInParams.push('\'projectId\'');
    }
    if ($missingRequiredInParams.length) {
    }
    let $url = `${environment.backendUrl}api/`;
    
    const $options = {
    }
    
    const $body = $inParams;
    
    return this.$utils.http.post($url, $body, $options);
    
  }
  public async getList($inParams: { warehouseId: number, materialId?: number, packagingId?: number, lotId?: number, projectId: number, fullTextSearch?: string, custom_filters?: string[], $top?: number, $skip?: number, $filter?: { operator: ('and' | 'or'), operands: { numberFilters?: { column: ('WarehouseId' | 'LotId' | 'PackagedId' | 'PackagedAmount' | 'Lot.MaterialId'), operation: ('equals' | 'notEqual' | 'empty' | 'lessThan' | 'lessThanOrEqual' | 'greaterThan' | 'greaterThanOrEqual'), value: number }[], numberMultiFilters?: { column: ('WarehouseId' | 'LotId' | 'PackagedId' | 'PackagedAmount' | 'Lot.MaterialId'), operation: ('in' | 'notIn'), value: number[] }[], stringFilters?: { column: ('Lot.LookupCode' | 'Lot.VendorLot.LookupCode' | 'Lot.VendorLot.Vat' | 'Lot.Material.Description' | 'Lot.Material.LookupCode' | 'Lot.Material.Name' | 'Lot.Status.Name' | 'Packaging.ShortName'), operation: ('equals' | 'notEqual' | 'empty' | 'contains' | 'notContains' | 'startsWith' | 'endsWith' | 'blank' | 'notBlank'), value: string }[], stringMultiFilters?: { column: ('Lot.LookupCode' | 'Lot.VendorLot.LookupCode' | 'Lot.VendorLot.Vat' | 'Lot.Material.Description' | 'Lot.Material.LookupCode' | 'Lot.Material.Name' | 'Lot.Status.Name' | 'Packaging.ShortName'), operation: ('in' | 'notIn'), value: string[] }[], dateFilters?: { column: ('Lot.LastReceiveDate' | 'Lot.VendorLot.ExpirationDate' | 'Lot.VendorLot.ManufactureDate'), operation: ('equals' | 'notEqual' | 'empty' | 'lessThan' | 'lessThanOrEqual' | 'greaterThan' | 'greaterThanOrEqual'), value: string }[], operator: ('and' | 'or') }[] } }): 
  Promise<{ result: { WarehouseId?: number, LotId?: number, PackagedId?: number, PackagedAmount?: number, Lot?: { LastReceiveDate?: string, LookupCode?: string, MaterialId?: number, VendorLot?: { ExpirationDate?: string, LookupCode?: string, ManufactureDate?: string, Vat?: string }, Material?: { Description?: string, LookupCode?: string, Name?: string }, Status?: { Name?: string } }, Packaging?: { ShortName?: string } }[], totalCount: number }> 
  {
    const $missingRequiredInParams = [];
    if (isNil($inParams.warehouseId)) {
      $missingRequiredInParams.push('\'warehouseId\'');
    }
    if (isNil($inParams.projectId)) {
      $missingRequiredInParams.push('\'projectId\'');
    }
    if ($missingRequiredInParams.length) {
    }
    let $url = `${environment.backendUrl}api/`;
    
    const $options = {
    }
    
    const $body = $inParams;
    
    return this.$utils.http.post($url, $body, $options);
    
  }
  public async getByKeys($inParams: { warehouseId: number, materialId?: number, packagingId?: number, lotId?: number, projectId: number, fullTextSearch?: string, custom_filters?: string[], $keys: { WarehouseId?: number, LotId?: number, PackagedId?: number }[] }): 
  Promise<{ result: { WarehouseId?: number, LotId?: number, PackagedId?: number, PackagedAmount?: number, Lot?: { LastReceiveDate?: string, LookupCode?: string, MaterialId?: number, VendorLot?: { ExpirationDate?: string, LookupCode?: string, ManufactureDate?: string, Vat?: string }, Material?: { Description?: string, LookupCode?: string, Name?: string }, Status?: { Name?: string } }, Packaging?: { ShortName?: string } }[] }> 
  {
    const $missingRequiredInParams = [];
    if (isNil($inParams.warehouseId)) {
      $missingRequiredInParams.push('\'warehouseId\'');
    }
    if (isNil($inParams.projectId)) {
      $missingRequiredInParams.push('\'projectId\'');
    }
    if (isNil($inParams.$keys)) {
      $missingRequiredInParams.push('\'$keys\'');
    }
    if ($missingRequiredInParams.length) {
    }
    let $url = `${environment.backendUrl}api/`;
    
    const $options = {
    }
    
    const $body = $inParams;
    
    return this.$utils.http.post($url, $body, $options);
    
  }


    
    hasMissingRequiredInParams($inParams: { 
      warehouseId: number, materialId?: number, packagingId?: number, lotId?: number, projectId: number, fullTextSearch?: string, custom_filters?: string[]    }) {
        if(isNil($inParams.warehouseId)) {
          return true; 
        }
        if(isNil($inParams.projectId)) {
          return true; 
        }
      return false;
    }
}
